import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Button } from "@/components/ui/button";
import { LeadDialog } from "@/components/LeadDialog";
import { useContent } from "@/hooks/useData";
import { ShieldCheck, Ruler, Ship, Sparkles, Handshake, ClipboardCheck } from "lucide-react";

const ICONS = [Sparkles, Ruler, ClipboardCheck, ShieldCheck, Ship, Handshake];

export default function Services() {
  const { content } = useContent();
  const c = content.services_page || {};
  const items = c.items || [];
  return (
    <div data-testid="services-page">
      <PageHeader eyebrow={c.header_eyebrow} title={c.header_title} accent={c.header_accent} description={c.header_description} />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#ECEAE4] border border-[#ECEAE4]">
          {items.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={`${s.title}-${i}`} delay={(i % 3) * 0.06} className="bg-[#FFFFFF] p-8 sm:p-10">
                <Icon size={28} className="text-[#9E8773]" strokeWidth={1.4} />
                <h3 className="font-display text-2xl font-medium text-[#2C2A29] mt-5">{s.title}</h3>
                <p className="text-[#5E5A54] font-light leading-relaxed mt-3">{s.description}</p>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-[#2C2A29]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <SectionHeading light eyebrow={c.trade_eyebrow} title={c.trade_title} accent={c.trade_accent} description={c.trade_description} />
          <div className="flex lg:justify-end">
            <LeadDialog
              type="quote"
              title="Discuss a Contract Project"
              description="Tell us about your development or commercial project and we'll prepare a tailored programme."
              trigger={<Button className="rounded-none bg-[#FFFFFF] text-[#2C2A29] hover:bg-[#ECEAE4] h-14 px-10 label-eyebrow text-[11px]" data-testid="services-contract-button">{c.trade_button}</Button>}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
